import { cva } from "class-variance-authority";

export const fieldFocusClasses =
    "outline-none transition-colors " +
    "focus:border-[0.5px] focus:border-[color:var(--primary)] " +
    "focus-within:border-[0.5px] focus-within:border-[color:var(--primary)]";

export const fieldInvalidClasses =
    "aria-invalid:border-[color:hsl(var(--destructive))] " +
    "aria-invalid:focus:border-[color:hsl(var(--destructive))] " +
    "aria-invalid:focus-within:border-[color:hsl(var(--destructive))]";

export const fieldVariants = cva(
    "box-border w-full rounded-md bg-white border-[0.5px] border-gray-300 text-sm text-gray-900 " +
    "placeholder:text-gray-400 disabled:cursor-not-allowed disabled:opacity-60 " +
    `${fieldFocusClasses} ${fieldInvalidClasses}`,
    {
        variants: {
            size: {
                default: "h-9 px-3",
                multi: "min-h-9",
            },
        },
        defaultVariants: {
            size: "default",
        },
    }
);

export const fieldLabelClasses =
    "block text-[10.5px] font-semibold uppercase tracking-[0.05em] text-gray-500";

export const fieldErrorClasses = "text-xs leading-4 text-red-600";
